import { FormBase } from 'core/components';

export default class TeamEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'Name',
                    placeholder: 'TEAMS.EDIT.NAME_PLACEHOLDER',
                    rules: 'required'
                },
                {
                    name: 'userIds',
                    label: 'TEAMS.EDIT.USERS_LABEL',
                    placeholder: 'TEAMS.EDIT.USERS',
                }],
        };
    }
}
